import cloneDeep from "lodash-es/cloneDeep";

/* eslint-disable */
export const generateBork = lang => {
  try {
    const clone = cloneDeep(lang);

    //clean(clone, lang);

    const keys = Object.keys(clone);
    keys.forEach(key => {
      const str = clone[key];

      if (typeof str === "string") {
        clone[key] = encheferizeLine(str);
      } else {
        clone[key] = generateBork(str, lang);
      }
    });

    return clone;
  } catch (e) {
    // no-op
  }
};

function borkLastChar(s) {
  const c = s[s.length - 1];

  return ["!", "."].includes(c);
}

const substitutions = {
  "@reference": /\$t\(.+\)/g,
  "@react": /<.+>/g,
  "@replace@": /\{\{.+?\}\}/g
};

function encheferizeLine(line) {
  const tracker = {};

  let l = line;

  for (let [key, value] of Object.entries(substitutions)) {
    const matches = l.match(value);

    if (matches) {
      matches.forEach(match => {
        l = l.replace(match, key);
      });

      tracker[key] = matches;
    }
  }

  const split = l.split(" ");

  const mapped = split.map((s, i) => {
    let subbed = false;
    Object.keys(substitutions).forEach(sub => {
      if (s.includes(sub)) {
        subbed = true;
      }
    });

    if (subbed) {
      return s;
    }

    if (i === split.length - 1 && borkLastChar(s)) {
      return encheferizeWord(s) + " Bork bork bork!";
    }

    return encheferizeWord(s);
  });

  let str = mapped.join(" ");

  for (let [key, value] of Object.entries(tracker)) {
    value.forEach(match => {
      str = str.replace(key, match);
    });
  }

  return str;
}

/*
 * This script translates English to mock-Swedish a-la the Swedish Chef
 * The translation rules were taken from Andriy Rozeluk <andriy.rozeluk@utoronto.ca>
 * Source at http://www.tuco.de/home/jschef.htm
 */

function encheferizeWord(word) {
  if (word.toLowerCase() === "bork") return word;

  let letter = "",
    count = 0,
    len = word.length,
    buff = "",
    i_seen = false,
    isLast = 0;

  while (count < len) {
    isLast = count == len - 1;
    letter = word.charAt(count);

    if (count === 0) {
      //Beginning-of-word rules
      switch (letter) {
        case "e":
          buff += "i";
          count++;
          continue;
        case "E":
          buff += "I";
          count++;
          continue;
        case "o":
          buff += "oo";
          count++;
          continue;
        case "O":
          buff += "Oo";
          count++;
          continue;
      }
    } else {
      //End of Beginning-of-word rules, Start of In-Word rules
      switch (letter) {
        case "e":
          if (!isLast && word.charAt(count + 1) == "w") {
            buff += "oo";
            count += 2;
            continue;
          } else if (isLast) {
            buff += "e-a";
            count++;
            continue;
          }
        case "f":
          buff += "ff";
          count++;
          continue;
        case "i":
          if (!isLast && word.charAt(count + 1) == "r") {
            buff += "ur";
            count += 2;
            continue;
          } else if (!i_seen) {
            buff += "ee";
            count++;
            i_seen = true;
            continue;
          }
        case "o":
          if (!isLast && word.charAt(count + 1) == "w") {
            buff += "oo";
            count += 2;
            continue;
          } else {
            buff += "u";
            count++;
            continue;
          }
        case "t":
          if (
            count <= len - 4 &&
            word.charAt(count + 1) == "i" &&
            word.charAt(count + 2) == "o" &&
            word.charAt(count + 3) == "n"
          ) {
            buff += "shun";
            count += 4;
            continue;
          }
        case "u":
          buff += "oo";
          count++;
          continue;
        case "U":
          buff += "Oo";
          count++;
          continue;
      }
    }
    //Word-placement rules, Start of Anywhere rules
    if (letter === "A" && !isLast) {
      switch (word.charAt(count + 1)) {
        case "n":
          buff += "Un";
          count += 2;
          continue;
        case "u":
          buff += "Oo";
          count += 2;
          continue;
        default:
          buff += "E";
          count++;
          continue;
      }
    } else if (letter === "a" && !isLast) {
      switch (word.charAt(count + 1)) {
        case "n":
          buff += "un";
          count += 2;
          continue;
        case "u":
          buff += "oo";
          count += 2;
          continue;
        default:
          buff += "e";
          count++;
          continue;
      }
    } else if (
      letter == "e" &&
      !isLast &&
      word.charAt(count + 1) == "n" &&
      count == len - 2
    ) {
      buff = buff + "ee";
      count += 2;
      continue;
    } else if (letter == "t") {
      if (count == len - 2 && word.charAt(count + 1) == "h") {
        buff += "t";
        count += 2;
        continue;
      } else if (
        count <= len - 3 &&
        word.charAt(count + 1) == "h" &&
        word.charAt(count + 2) == "e"
      ) {
        buff += "zee";
        count += 3;
        continue;
      }
    } else if (
      count <= len - 3 &&
      word.charAt(count + 1) == "h" &&
      word.charAt(count + 2) == "e"
    ) {
      switch (letter) {
        case "T":
          buff += "Zee";
          count += 3;
          continue;
        case "v":
          buff += "f";
          count++;
          continue;
        case "V":
          buff += "F";
          count++;
          continue;
        case "w":
          buff += "v";
          count++;
          continue;
        case "W":
          buff += "V";
          count++;
          continue;
      }
    }
    //End of rules.  Whatever is left stays itself
    buff += letter;
    count++;
  }
  return buff;
}
